"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HydrogenEndpoints = void 0;
const constant_1 = require("../constant");
const util_1 = require("../util");
const dayjs_1 = __importDefault(require("dayjs"));
exports.HydrogenEndpoints = {
    // Status api
    stats: "/stats",
    // Transfer Payloads api
    transfer_payloads: "/transfer_payloads",
    // Relays api
    relays: "/relays",
    // Fee service api
    fee_quote: "/fee_quote",
};
const formatDateField = (value) => {
    if (typeof value !== "string")
        return null;
    return dayjs_1.default(value);
};
// temporary function to parse okt/okc blockchain
// to remove when automatic deposit/withdraw feature is deployed
const parseHydrogenBlockchain = (blockchain) => {
    if (blockchain === "okx")
        return util_1.BlockchainUtils.Blockchain.Okc;
    return util_1.BlockchainUtils.parseBlockchain(blockchain);
};
const formatCrossChainTransfer = (value) => {
    var _a, _b;
    if (typeof value !== "object")
        return value;
    return Object.assign(Object.assign({}, value), { created_at: formatDateField((_a = value.created_at) === null || _a === void 0 ? void 0 : _a.toString()), updated_at: formatDateField((_b = value.updated_at) === null || _b === void 0 ? void 0 : _b.toString()), source_blockchain: parseHydrogenBlockchain(value.source_blockchain), bridging_blockchain: parseHydrogenBlockchain(value.bridging_blockchain), destination_blockchain: parseHydrogenBlockchain(value.destination_blockchain) });
};
const formatCrossChainTransferDetailed = (value) => {
    if (!value || typeof value !== "object")
        return value;
    return Object.assign(Object.assign({}, formatCrossChainTransfer(value)), { source_event: formatChainEvent(value.source_event), bridging_event: formatChainEvent(value.bridging_event), destination_event: formatChainEvent(value.destination_event) });
};
const formatRelaysTransfers = (value) => {
    var _a, _b;
    if (!value || typeof value !== "object")
        return value;
    return Object.assign(Object.assign({}, value), { created_at: formatDateField((_a = value.created_at) === null || _a === void 0 ? void 0 : _a.toString()), updated_at: formatDateField((_b = value.updated_at) === null || _b === void 0 ? void 0 : _b.toString()), source_blockchain: parseHydrogenBlockchain(value.source_blockchain), destination_blockchain: parseHydrogenBlockchain(value.destination_blockchain) });
};
const formatChainEvent = (value) => {
    var _a, _b, _c;
    if (!value || typeof value !== "object")
        return value;
    return Object.assign(Object.assign({}, value), { confirmed_at: formatDateField((_a = value.confirmed_at) === null || _a === void 0 ? void 0 : _a.toString()), created_at: formatDateField((_b = value.created_at) === null || _b === void 0 ? void 0 : _b.toString()), updated_at: formatDateField((_c = value.updated_at) === null || _c === void 0 ? void 0 : _c.toString()), blockchain: parseHydrogenBlockchain(value.blockchain) });
};
const formatFeeQuote = (value) => {
    var _a, _b;
    if (typeof value !== "object")
        return value;
    return Object.assign(Object.assign({}, value), { blockchain: parseHydrogenBlockchain(value.blockchain), created_at: formatDateField((_a = value.created_at) === null || _a === void 0 ? void 0 : _a.toString()), expires_at: formatDateField((_b = value.expires_at) === null || _b === void 0 ? void 0 : _b.toString()) });
};
const getBridgeBlockchainFromId = (bridgeId) => {
    switch (bridgeId) {
        case 1:
            return 'Polynetwork';
        case 2:
            return 'Ibc';
        default:
            return 'Polynetwork';
    }
};
class HydrogenClient {
    constructor(config, tokenClient) {
        this.config = config;
        this.formatCrossChainTransferV2 = (value) => {
            var _a, _b, _c, _d;
            if (typeof value !== "object")
                return value;
            return Object.assign(Object.assign({}, value), { created_at: formatDateField((_a = value.created_at) === null || _a === void 0 ? void 0 : _a.toString()), updated_at: formatDateField((_b = value.updated_at) === null || _b === void 0 ? void 0 : _b.toString()), source_blockchain: this.tokenClient.getBlockchainV2FromIDs(value.from_chain_id, value.bridge_id), bridging_blockchain: getBridgeBlockchainFromId(value.bridge_id), destination_blockchain: this.tokenClient.getBlockchainV2FromIDs(value.to_chain_id, value.bridge_id), source_event: this.formatChainEventV2(value.source_event, (_c = value.source_blockchain) !== null && _c !== void 0 ? _c : ''), bridging_event: this.formatChainEventV2(value.bridging_event, getBridgeBlockchainFromId(value.bridge_id)), destination_event: this.formatChainEventV2(value.destination_event, (_d = value.destination_blockchain) !== null && _d !== void 0 ? _d : ''), relay: this.formatRelaysTransfersV2(value.relay) });
        };
        this.formatCrossChainTransferDetailedV2 = (value) => {
            if (!value || typeof value !== "object")
                return value;
            const source_blockchain = this.tokenClient.getBlockchainV2FromIDs(value.from_chain_id, value.bridge_id);
            const destination_blockchain = this.tokenClient.getBlockchainV2FromIDs(value.to_chain_id, value.bridge_id);
            const bridging_blockchain = getBridgeBlockchainFromId(value.bridge_id);
            return Object.assign(Object.assign({}, this.formatCrossChainTransferV2(value)), { source_event: this.formatChainEventV2(value.source_event, source_blockchain !== null && source_blockchain !== void 0 ? source_blockchain : ''), bridging_event: this.formatChainEventV2(value.bridging_event, bridging_blockchain), destination_event: this.formatChainEventV2(value.destination_event, destination_blockchain !== null && destination_blockchain !== void 0 ? destination_blockchain : '') });
        };
        this.formatRelaysTransfersV2 = (value) => {
            var _a, _b;
            if (!value || typeof value !== "object")
                return value;
            return Object.assign(Object.assign({}, value), { created_at: formatDateField((_a = value.created_at) === null || _a === void 0 ? void 0 : _a.toString()), updated_at: formatDateField((_b = value.updated_at) === null || _b === void 0 ? void 0 : _b.toString()) });
        };
        this.formatChainEventV2 = (value, blockchain) => {
            var _a, _b, _c;
            if (!value || typeof value !== "object")
                return value;
            return Object.assign(Object.assign({}, value), { confirmed_at: formatDateField((_a = value.confirmed_at) === null || _a === void 0 ? void 0 : _a.toString()), created_at: formatDateField((_b = value.created_at) === null || _b === void 0 ? void 0 : _b.toString()), updated_at: formatDateField((_c = value.updated_at) === null || _c === void 0 ? void 0 : _c.toString()), blockchain });
        };
        this.formatFeeQuoteV2 = (value, blockchain) => {
            var _a, _b;
            if (typeof value !== "object")
                return value;
            return Object.assign(Object.assign({}, value), { blockchain, created_at: formatDateField((_a = value.created_at) === null || _a === void 0 ? void 0 : _a.toString()), expires_at: formatDateField((_b = value.expires_at) === null || _b === void 0 ? void 0 : _b.toString()) });
        };
        this.apiManager = new util_1.APIUtils.APIManager(config.hydrogenUrl, exports.HydrogenEndpoints);
        this.tokenClient = tokenClient;
    }
    static instance(config, tokenClient) {
        return new HydrogenClient(config, tokenClient);
    }
    checkState() {
        var _a;
        if (!((_a = this.apiManager.apiPrefix) === null || _a === void 0 ? void 0 : _a.length)) {
            if ([constant_1.Network.TestNet, constant_1.Network.LocalHost].includes(this.config.network))
                throw new Error(`hydrogen service not available on ${this.config.network}`);
            throw new Error("hydrogen api url is empty");
        }
    }
    // Status api
    getStats() {
        return __awaiter(this, void 0, void 0, function* () {
            this.checkState();
            const request = this.apiManager.path("stats");
            const response = yield request.get();
            return response.data;
        });
    }
    getTransfers(req, version = "V1") {
        return __awaiter(this, void 0, void 0, function* () {
            this.checkState();
            const request = this.apiManager.path("transfer_payloads", {}, Object.assign({}, req));
            const response = yield request.get();
            const result = response.data;
            return Object.assign(Object.assign({}, result), { data: result.data.map(version === "V1" ? formatCrossChainTransfer : this.formatCrossChainTransferV2) });
        });
    }
    getDetailedTransfers(req, version = "V1") {
        return __awaiter(this, void 0, void 0, function* () {
            this.checkState();
            const request = this.apiManager.path("transfer_payloads", {}, Object.assign(Object.assign({}, req), { include_tx: true }));
            const response = yield request.get();
            const result = response.data;
            return Object.assign(Object.assign({}, result), { data: result.data.map(version === "V1" ? formatCrossChainTransferDetailed : this.formatCrossChainTransferDetailedV2) });
        });
    }
    getRelaysTransfers(req, version = "V1") {
        return __awaiter(this, void 0, void 0, function* () {
            this.checkState();
            const request = this.apiManager.path("relays", {}, Object.assign(Object.assign({}, req), { include_tx: true }));
            const response = yield request.get();
            const result = response.data;
            return Object.assign(Object.assign({}, result), { data: result.data.map(version === "V1" ? formatRelaysTransfers : this.formatRelaysTransfersV2) });
        });
    }
    getFeeQuote(req, blockchain = undefined, version = "V1") {
        return __awaiter(this, void 0, void 0, function* () {
            this.checkState();
            const request = this.apiManager.path("fee_quote", {}, Object.assign({}, req));
            const response = yield request.post({ body: { fee_denoms: req.fee_denoms } });
            const result = response.data;
            return version === "V1" ? formatFeeQuote(result) : this.formatFeeQuoteV2(result, blockchain);
        });
    }
}
exports.default = HydrogenClient;
